import { render, staticRenderFns } from "./BundleTagsForm.vue?vue&type=template&id=2b550fbc&scoped=true&"
import script from "./BundleTagsForm.vue?vue&type=script&lang=js&"
export * from "./BundleTagsForm.vue?vue&type=script&lang=js&"
import style0 from "./BundleTagsForm.vue?vue&type=style&index=0&id=2b550fbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b550fbc",
  null
  
)

export default component.exports